import React, { MouseEvent } from 'react'

import clsx from 'clsx'

import { LineLimitTxt } from 'src/components/atoms'
import { BoldSubstrings } from 'src/components/atoms/texts/BoldSubstrings'

import { useUser } from 'src/hooks'
import { ProfileEntity, UserEntity } from 'src/types'

type Props<T extends UserEntity> = {
  user: T
  profile?: ProfileEntity
  searchWords?: string[]
  onSelect: (user: T) => void
  className?: string
}

export const SearchedUserListItem = <T extends UserEntity>({
  user,
  profile,
  searchWords,
  onSelect,
  className,
}: Props<T>) => {
  const handleOnSelect = (event: MouseEvent, selectedUser: T) => {
    event.stopPropagation()
    onSelect(selectedUser)
  }

  const { isInternalUser } = useUser()

  return (
    <div className={className}>
      <div
        role="presentation"
        className="tw-p-[1.14rem] tw-bg-surface-primary hover:tw-bg-surface-secondary tw-cursor-pointer"
        onClick={event => handleOnSelect(event, user)}
      >
        <div className="tw-flex tw-gap-s-1">
          {user.name && (
            <LineLimitTxt
              maxLineLimit={1}
              className={clsx('tw-min-w-[40%]', profile?.id === user.id && 'tw-text-pattern6-3')}
            >
              <BoldSubstrings substrings={searchWords ?? []}>{user.name}</BoldSubstrings>
            </LineLimitTxt>
          )}
          <LineLimitTxt maxLineLimit={1} className="tw-text-standardText-secondary">
            <BoldSubstrings substrings={searchWords ?? []}>{user.email}</BoldSubstrings>
          </LineLimitTxt>
          {user.keywords.length > 0 && (
            <LineLimitTxt maxLineLimit={1} className="tw-text-standardText-secondary">
              <BoldSubstrings substrings={searchWords ?? []}>
                {user.keywords.join(', ')}
              </BoldSubstrings>
            </LineLimitTxt>
          )}
          {isInternalUser(user) && user.customRoles.length > 0 && (
            <LineLimitTxt maxLineLimit={1} className="tw-text-standardText-secondary">
              <BoldSubstrings substrings={searchWords ?? []}>
                {user.customRoles.map(customRole => customRole.name).join(', ')}
              </BoldSubstrings>
            </LineLimitTxt>
          )}
        </div>
      </div>
    </div>
  )
}
